"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  p,\n  li {\n    line-height: 2 !important;\n    font-size: ", ";\n  }\n  h2 {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n  h3 {\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n  ul {\n    list-style: none none;\n    padding-left: ", ";\n    margin: ", " 0;\n    li {\n      margin: ", " 0;\n      padding-left: ", ";\n      position: relative;\n      font-size: ", ";\n      &:before {\n        display: block;\n        content: ' ';\n        position: absolute;\n        top: 0.65em;\n        left: 0;\n        width: 8px;\n        height: 8px;\n        background: ", ";\n        border-radius: 50%;\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LargeProse = void 0;

var styledTypes_1 = require("./styledTypes");

exports.LargeProse = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@font-size-lg'];
}, function (props) {
  return props.theme['@size-xl'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-l'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-xs'];
}, function (props) {
  return props.theme['@size-m'];
}, function (props) {
  return props.theme['@font-size-lg'];
}, function (props) {
  return props.theme['@gray-2'];
});